@for (deliveryBase of deliveryBases; track deliveryBase; let isLast = $last) {
  <div>
    {{ deliveryBase }}@if (!isLast) {
    <span>,</span>
  }
  </div>
}

